import { render, staticRenderFns } from "./ItemData.vue?vue&type=template&id=e501c6f0&"
import script from "./ItemData.vue?vue&type=script&lang=ts&"
export * from "./ItemData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports